import { object, string } from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const SettingBlock = ({ children, title, boxProps }) => (
  <StyledSettingBlock {...boxProps}>
    {title && <SettingBlockHeader boxProps={{ mb: 4 }} title={title} />}
    {children}
  </StyledSettingBlock>
);

const SettingBlockHeader = ({ title, boxProps }) => (
  <StyledSettingBlockHeader {...boxProps}>{title}</StyledSettingBlockHeader>
);

export default SettingBlock;

const StyledSettingBlock = styled(Box).attrs(() => ({
  px: 20,
  flexDirection: 'column',
  mb: 5,
}))``;

const StyledSettingBlockHeader = styled(Box).attrs(() => ({
  color: 'asphalt',
  fontSize: 3,
  fontWeight: 700,
  mb: 5,
}))``;

SettingBlock.propTypes = {
  title: string,
  boxProps: object,
};
